import React, { useState } from 'react'
import * as XLSX from 'xlsx'
import UserForm from '../CreateUser/UserForm'
import { useNavigate } from 'react-router-dom'
import { signUp, saveUserProfile, uploadFile, getFileUrl } from '../supabase.config'

const AdminSignup = () => {
  const navigate = useNavigate()

  const [name, setName] = useState("")
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [companyName, setCompanyName] = useState("")
  const [gstNo, setGstNo] = useState("")
  const [gstDocument, setGstDocument] = useState("")
  const [agreement, setAgreement] = useState("")
  const [otherDoc, setOtherDoc] = useState("")
  const [insuranceType, setInsuranceType] = useState("")
  const [contact, setContact] = useState("")
  const [companyAddress, setCompanyAddress] = useState("")
  const [rateChart, setRateChart] = useState(null)
  const [rateJson, setRateJson] = useState("")

  const handleCreateUser = async () => {
    try {
      const { data, error } = await signUp(email, password, {
        name: name,
        role: 'admin'
      })

      if (error) {
        console.error('Signup error:', error)
        alert('Error creating user: ' + error.message)
        return
      }

      if (data.user) {
        const profileData = {
          name,
          email,
          contact,
          companyName,
          gstNo,
          gstDocument,
          agreement,
          otherDoc,
          insuranceType,
          companyAddress,
          role: 'admin',
          partnerType: 'postpaid',
          walletBalance: '',
          service: 'logistics',
          rateList: rateJson
        }

        const { error: profileError } = await saveUserProfile(data.user.id, profileData)
        if (profileError) {
          console.error('Error saving profile:', profileError)
          alert('User created but failed to save profile: ' + profileError.message)
          return
        }

        alert('Signup successful. You can now log in.')
        navigate('/login')
      }
    } catch (err) {
      console.error('Unexpected error:', err)
      alert('An unexpected error occurred: ' + err.message)
    }
  }

  const addGSTInformation = async (e) => {
    e.preventDefault()
    const file = e.target[0]?.files[0]
    if (!file) return
    try {
      const { error } = await uploadFile('documents', `gst/${file.name}`, file)
      if (error) {
        alert('Error uploading GST document: ' + error.message)
        return
      }
      const downloadURL = getFileUrl('documents', `gst/${file.name}`)
      setGstDocument(downloadURL)
    } catch (err) {
      alert('Error uploading file: ' + err.message)
    }
  }

  const addAgreementInformation = async (e) => {
    e.preventDefault()
    const file = e.target[0]?.files[0]
    if (!file) return
    try {
      const { error } = await uploadFile('documents', `agreements/${file.name}`, file)
      if (error) {
        alert('Error uploading agreement: ' + error.message)
        return
      }
      const downloadURL = getFileUrl('documents', `agreements/${file.name}`)
      setAgreement(downloadURL)
    } catch (err) {
      alert('Error uploading file: ' + err.message)
    }
  }

  const handleConvert = () => {
    if (rateChart) {
      const reader = new FileReader()
      reader.onload = (e) => {
        const data = e.target.result
        const workbook = XLSX.read(data, { type: 'binary' })
        const sheetName = workbook.SheetNames[0]
        const worksheet = workbook.Sheets[sheetName]
        const json = XLSX.utils.sheet_to_json(worksheet)
        setRateJson(json)
      }
      reader.readAsBinaryString(rateChart)
    }
  }

  return (
    <div className='min-h-screen bg-gray-100 flex items-start justify-center py-10'>
      <div className='w-full max-w-5xl'>
        <UserForm
          name={name} setName={setName}
          rateChart={rateChart} setRateChart={setRateChart}
          rateJson={rateJson} setRateJson={setRateJson}
          handleConvert={handleConvert}
          addAgreementInformation={addAgreementInformation}
          addGSTInformation={addGSTInformation}
          handleCreateUser={handleCreateUser}
          companyAddress={companyAddress} setCompanyAddress={setCompanyAddress}
          email={email} setEmail={setEmail}
          password={password} setPassword={setPassword}
          companyName={companyName} setCompanyName={setCompanyName}
          gstNo={gstNo} setGstNo={setGstNo}
          agreement={agreement} setAgreement={setAgreement}
          gstDocument={gstDocument} setGstDocument={setGstDocument}
          otherDoc={otherDoc} setOtherDoc={setOtherDoc}
          insuranceType={insuranceType} setInsuranceType={setInsuranceType}
          contact={contact} setContact={setContact}
        />
      </div>
    </div>
  )
}

export default AdminSignup

